import { ApexTokenModel } from "../typings/models/ApexTokenModel";
import { getConfig } from "./configService";
export const apexToken = () => {
  let APEX_BASE_URL = "";
  let APEX_BASE_ACCOUNTID = "";
  let APEX_BASE_SECRET = "";
  try {
    const cfg = getConfig();
    APEX_BASE_URL = cfg.REACT_APP_API_APEX_BASE_URL || APEX_BASE_URL;
    APEX_BASE_ACCOUNTID = cfg.REACT_APP_API_APEX_ACCOUNTID || APEX_BASE_ACCOUNTID;
    APEX_BASE_SECRET = cfg.REACT_APP_API_APEX_SECRET || APEX_BASE_SECRET;
  } catch (e) {
    // config not loaded yet — values stay empty
    console.warn('Config not loaded: APEX token values are empty');
  }
  var cryptojs = require('crypto-js');

    const GetApexToken = async (url:string) : Promise<ApexTokenModel> => {
        var accountId = APEX_BASE_ACCOUNTID;
        var secretkey = APEX_BASE_SECRET;
        var currentdate = new Date();
        var ts = currentdate.getTime();
        var nonce = Math.round(Math.random() * 4294967295 );
        var apiUrl=`${APEX_BASE_URL}${url}?accountid=${accountId}&nonce=${nonce}&ts=${ts}`
        var apexUrl = `POST&${apiUrl}`
        var hash = cryptojs.HmacSHA256(apexUrl, secretkey);
        var hashInBase64 = cryptojs.enc.Base64.stringify(hash);

        let tokenResult: ApexTokenModel = {
            jwtToken : hashInBase64,
            accountId: `${accountId}`,
            apexUrl: apiUrl,
            nonce: `${nonce}`,
            timestamp: `${ts}`,
          };
          return tokenResult
    }  

  return {
    GetApexToken
  }
}